import { apiClient } from './ApiClient';
import { Artifact } from './ArtifactService';
export type ReleaseResponse = {
  id: string;
  semver: string;
  artifacts: Artifact[];
  deviceType: string;
  isStable: boolean;
  createTime: string;
  lastUpdateTime: string;
};
export type Release = {
  id: string;
  artifactIds: string[];
  artifacts?: Artifact[];
  createTime?: string;
  description?: string;
  deviceType?: string;
  isStable?: boolean;
  isPromoted?: boolean;
  isDeployed?: boolean;
  lastUpdateTime?: string;
  semver?: string;
};

export type ReleaseInput = {
  artifactIds: string[];
  description?: string;
  releaseNotes?: string;
  deviceType: string;
  semver: string;
};

export const getRelease = async (id: string): Promise<ReleaseResponse> => {
  const response = await apiClient.getClient().get(`releases/${id}`);
  return response.data;
};
export const getReleases = async (): Promise<Release[]> => {
  const response = await apiClient.getClient().get(`releases`);
  return response.data.items;
};
export const promoteRelease = async (id: string): Promise<string> => {
  const response = await apiClient.getClient().post(`releases/${id}/promote`);
  return response.data;
};
export const createRelease = async (input: ReleaseInput): Promise<Release> => {
  const response = await apiClient.getClient().post(`releases`, input);
  return response.data;
};
